/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// @flow

import { PrivateStateAccessor } from '@ta/common.state';

/** Local storage key to indicate the page was reloaded after onboarding completed */
export const OnboardingCompleteReloadKey = 'social_onboarding_done_reload';

/**
 * The state of the private tooltip slice
 */
export type ScrollFeedTooltipState = {
  /**
   * A boolean tracking when the onboarding flow was closed
   */
  onboardingClosed: boolean,
  /**
   * Force show the scrolling
   */
  forceShowScrollTooltip: boolean,
  /**
   * Force show the login bar
   */
  forceShowLoginBar: boolean,
};

const KEY = 'social-scroll-tooltip';
const DEFAULT_STATE = {
  onboardingClosed: false,
  forceShowScrollTooltip: false,
  forceShowLoginBar: false,
};

const STATE_ACCESS: PrivateStateAccessor<ScrollFeedTooltipState> = new PrivateStateAccessor(
  KEY,
  DEFAULT_STATE,
);

/**
 * Allows exclusive access to the state
 */
export const getState = (state: any) => STATE_ACCESS.getFrom(state);

/**
 * Type def for the actions of our slice
 */
export type ScrollFeedTooltipActions = {
  /**
   * Defines the method that dispatches an onboarding complete action
   */
  onboardingDone: () => any,
  /**
   * Show the scrolling tooltip, disregard all other gates (slice, scrolling requirement, scoped home)
   */
  showScrollTooltip: () => void,

  /**
   * Force show the login bar on scroll
   */
  showLoginBar: () => void,
};

const SCROLL_FEED_TOOLTIP_SHOW = 'DONE_ONBOARDING';
const HOME_FEED_SCROLL_TOOLTIP_SHOW = 'SHOW_TOOLTIP';
const HOME_FEED_LOGIN_BAR_SHOW = 'SHOW_LOGIN_BAR';

/**
 * A list of action supported by this slice
 */
export const ACTIONS: ScrollFeedTooltipActions = {
  onboardingDone: () =>
    STATE_ACCESS.action({
      type: SCROLL_FEED_TOOLTIP_SHOW,
    }),
  showScrollTooltip: () =>
    STATE_ACCESS.action({
      type: HOME_FEED_SCROLL_TOOLTIP_SHOW,
    }),
  showLoginBar: () =>
    STATE_ACCESS.action({
      type: HOME_FEED_LOGIN_BAR_SHOW,
    }),
};

// Set the reducer for the private slice. You can only call this once.
STATE_ACCESS.setReducer((prevState: ScrollFeedTooltipState, action: any) => {
  switch (action.type) {
    case SCROLL_FEED_TOOLTIP_SHOW: {
      return {
        ...prevState,
        onboardingClosed: true,
      };
    }
    case HOME_FEED_SCROLL_TOOLTIP_SHOW: {
      return {
        ...prevState,
        forceShowScrollTooltip: true,
      };
    }
    case HOME_FEED_LOGIN_BAR_SHOW: {
      return {
        ...prevState,
        forceShowLoginBar: true,
      };
    }
    default:
      return prevState;
  }
});
